<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h1>TFA Corrections Submitted</h1>
        <callout type="info">
          The corrections to your TFA related documents have been successfully submitted. A City financial representative will continue their review of TFA and contact you if there are any outstanding issues. For questions, please email <a :href="`mailto:${financialSpecialistEmail}`"><u>{{ financialSpecialistEmail }}</u></a>. 
        </callout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResubmissionTFASuccess",
  props: {
    financialSpecialistEmail: {
      default: null,
      type: String,
    },
  },
};
</script>